import NewsSlideSettings from "./news-slide/NewsSlideSettings";
import OpeningSlideSettings from "./OpeningSlideSettings";

export default function StylingSettings({ styleSettings, handleStyleChange }) {
  return (
    <>
      <OpeningSlideSettings
        styleSettings={styleSettings}
        handleStyleChange={handleStyleChange}
      />
      <NewsSlideSettings
        styleSettings={styleSettings}
        handleStyleChange={handleStyleChange}
      />
    </>
  );
}
